export function openMap() {
	document.addEventListener('click', function (event) {
		const wrapper = document.querySelector('.filter-map-wrapper')
		if (!wrapper) return

		if (event.target.closest('.map--button')) {
			wrapper.classList.add('map-visible')
		}

		if (event.target.closest('.map--button--close')) {
			wrapper.classList.remove('map-visible')
		}
	})
}
